import { Breadcrumbs as MUIBreadcrumbs } from "@mui/material";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import styles from "./Breadcrumbs.module.scss";

export interface BreadcrumbProps {
    link: string;
    label: ReactNode;
}

export const Breadcrumbs = ({ breadcrumbs }: { breadcrumbs: BreadcrumbProps[] }) => {
    return (
        <MUIBreadcrumbs
            separator="›"
            aria-label="breadcrumb"
            className={styles.breadcrumbsContainer}
        >
            {breadcrumbs.map((item, index, array) =>
                index === array.length - 1 ? (
                    <div key={item.link} className={styles.breadcrumbsItem}>
                        <div>{item.label}</div>
                    </div>
                ) : (
                    <Link
                        to={item.link}
                        key={item.link}
                        className={`${styles.breadcrumbsItem} ${styles.breadcrumbsLink}`}
                    >
                        <div>{item.label}</div>
                    </Link>
                )
            )}
        </MUIBreadcrumbs>
    );
};
